import { Msg } from "../../../imsdk/db/t_msg";
import { hideLoading, showLoading } from "../../components/Loading";
import { Str_Cancel, Str_ClearChatHistory, Str_Clearing, Str_Confirm } from "../../language/string_res";
import { postJson } from "../../net/http";
import { useChatStore } from "../../store/ChatStore";
import { useStore } from "../../store/UserStore";
import * as ImSdk from "../../../imsdk/api";
import { Modal, SafeAreaView, Text, TouchableOpacity, View } from "react-native";
import { color_3C3C3C, ColorRed, color_main, white } from "../../assets/style/colors";

export const CleanHistoryModal = (props: {
    tid: string,
    vis: boolean,
    setVis: (vis: boolean) => void
}) => {
    const { chatDispatch } = useChatStore()
    const { dispatch } = useStore();

    const dismiss = () => {
        props.setVis(false);
    };
    const clean = async () => {
        props.setVis(false);
        showLoading(Str_Clearing)
        const res = await postJson<{ msgs?: Msg[] }>("/v1/sdk/msg/history", {
            body: {
                tid: props.tid,
                size: 1,
                containMax: true
            }
        })
        let msg
        if (res && res.data && res.data.msgs && res.data.msgs.length > 0) {
            msg = res.data.msgs[0];
        }
        ImSdk.getInstance().CleanMsg(props.tid, msg?.mid).then((value: { code: number; }) => {
            if (value.code !== -1) {
                chatDispatch({ type: "CHAT_CLEAN_MSG", payload: { tid: props.tid } })
                dispatch({ type: 'CLEAN_MSG', payload: props.tid });
            }
            hideLoading()
        }).finally(() => {
            hideLoading()
        });
    };

    return <Modal
        statusBarTranslucent={true}
        animationType={"fade"}
        transparent={true}
        onRequestClose={dismiss} visible={props.vis}>
        <TouchableOpacity
            style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.5)", justifyContent: 'center', alignItems: 'center' }}
            activeOpacity={1}
            onPress={dismiss}>
            <SafeAreaView
                style={{
                    width: '85%',
                    maxWidth: 500,
                    backgroundColor: white,
                    borderRadius: 20,
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.3,
                    shadowRadius: 8,
                    elevation: 8,
                }}>
                <TouchableOpacity activeOpacity={1} onPress={(e) => e.stopPropagation()}>
                    <View style={{ padding: 28 }}>
                        <Text style={{ 
                            fontSize: 20, 
                            fontWeight: '600', 
                            color: '#1A1A1A', 
                            textAlign: 'center',
                            marginBottom: 12,
                            marginTop: 8,
                            letterSpacing: 0.3,
                        }}>{Str_ClearChatHistory}</Text>
                        <Text style={{ 
                            fontSize: 15, 
                            color: '#666', 
                            textAlign: 'center',
                            marginBottom: 28,
                            lineHeight: 22,
                            paddingHorizontal: 8,
                        }}>确定要清空聊天记录吗？此操作不可恢复。</Text>
                        <View style={{ 
                            flexDirection: 'row', 
                            justifyContent: 'space-between',
                            gap: 12
                        }}>
                            <TouchableOpacity
                                activeOpacity={0.8}
                                style={{
                                    flex: 1,
                                    backgroundColor: '#F5F5F5',
                                    borderRadius: 10,
                                    paddingVertical: 16,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderWidth: 1,
                                    borderColor: '#E0E0E0',
                                }}
                                onPress={dismiss}>
                                <Text style={{ fontSize: 16, color: color_3C3C3C, fontWeight: '500' }}>{Str_Cancel}</Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                                activeOpacity={0.8}
                                style={{
                                    flex: 1,
                                    backgroundColor: ColorRed,
                                    borderRadius: 10,
                                    paddingVertical: 16,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    shadowColor: ColorRed,
                                    shadowOffset: { width: 0, height: 2 },
                                    shadowOpacity: 0.3,
                                    shadowRadius: 4,
                                    elevation: 3,
                                }}
                                onPress={clean}>
                                <Text style={{ fontSize: 16, color: white, fontWeight: '600' }}>{Str_Confirm}</Text>
                            </TouchableOpacity>
                        </View>
                    </View>
                </TouchableOpacity>
            </SafeAreaView>
        </TouchableOpacity>
    </Modal>;
};